/**
 * Render a footer element with a paragraph element containing the text 'Copyright
 * 2020 Argent Bank'.
 *
 * @category Components
 * @component
 * @returns { React.Component } A React component
 */
function Footer() {
	return (
		<footer className="footer">
			<p className="footer-text">Copyright 2020 Argent Bank</p>
		</footer>
	);
}

export default Footer;